import { useState, useEffect } from 'react';
import { SelectButton, PopoverSheet } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { ndsSelectButtonInteraction } from 'reaxl-analytics-handlers';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function SelectButtonWrapper(_ref) {
  let {
    analyticProps,
    buttonLabel,
    children,
    className,
    disabled,
    heading,
    position,
    primaryLabel,
    secondaryLabel,
    containerElement,
    hideCTA,
    inputCompletedState,
    onSupportingLinkClick = () => {},
    isSupportingLinkClicked,
    ...rest
  } = _ref;
  const [isActive, setIsActive] = useState(false);
  const clickHandler = () => {
    setIsActive(!isActive);
    onSupportingLinkClick(false);
    const {
      cmp,
      userModified,
      handleNDSClick
    } = analyticProps || {};
    if (!isActive && cmp) {
      sendClick(ndsSelectButtonInteraction, {}, {
        cmp
      });
    }
    if (typeof handleNDSClick === 'function') {
      handleNDSClick({}, userModified);
    }
  };

  // When user click the Supporting link, the popover should be closed
  useEffect(() => {
    if (isSupportingLinkClicked) {
      setIsActive(false);
    }
  }, [isSupportingLinkClicked]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(SelectButton, {
      disabled: disabled,
      onClick: clickHandler,
      isActive: isActive,
      primaryLabel: primaryLabel,
      secondaryLabel: secondaryLabel,
      inputCompletedState: inputCompletedState,
      ...rest
    }), /*#__PURE__*/jsx(PopoverSheet, {
      show: isActive,
      onClick: () => {
        setIsActive(false);
        onSupportingLinkClick(false);
      },
      heading: heading,
      buttonLabel: buttonLabel,
      className: className,
      containerElement: containerElement,
      position: position,
      hideCTA: hideCTA,
      children: children
    })]
  });
}
export { SelectButtonWrapper as default };
